import { client } from '../client';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const confirmMedia = async (conversationSid: string, mediaId: string, userRole?: string): Promise<Response> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.patch<Response>(
    `${prefix}/conversations/${conversationSid}/media/${mediaId}/confirm`,
    {},
  );

  return data;
};
